import { DropShadow } from 'glints-aries/lib/@next';
import { borderRadius8 } from 'glints-aries/lib/@next/utilities/borderRadius';
import { Blue } from 'glints-aries/lib/@next/utilities/colors';
import styled, { css } from 'styled-components';

import {
  CARD_SHADOW_HOVER,
  CONTENT_MAX_WIDTH,
  MOBILE_BREAKPOINT,
} from '../constants';

export const SGInner = styled.div`
  max-width: ${CONTENT_MAX_WIDTH}px;
  margin: 0 auto;
  padding: 0 24px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    padding: 0 20px;
  }
`;

/**
 * Base styles for the pill CTA links used in AudienceCards and OneGlints.
 * Consumers add their own `background` / `color` after this fragment.
 */
export const sgCtaBase = css`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 22px;
  border-radius: ${borderRadius8};
  font-weight: 700;
  font-size: 15px;
  line-height: 1;
  min-height: 44px;
  text-decoration: none;
  cursor: pointer;
  border: 0;
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease,
    background 0.15s ease;
  box-shadow: ${DropShadow.card};

  &:hover {
    transform: translateY(-1px);
    box-shadow: ${CARD_SHADOW_HOVER};
  }

  &:active {
    transform: translateY(0);
  }

  &:focus-visible {
    outline: 2px solid ${Blue.S99};
    outline-offset: 3px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: background 0.15s ease;

    &:hover {
      transform: none;
    }
  }
`;
